// store/actualities.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useActualitiesStore = defineStore('actualities', () => {
  const actualities = ref([])
  const actualitiesToday = ref([])
  const actualitiesProgram = ref([])
  const actualitiesNotice = ref([])
  const actualitiesArchive = ref([])

  const restart = () => {
    actualities.value = []
    actualitiesToday.value = []
    actualitiesProgram.value = []
    actualitiesNotice.value = []
    actualitiesArchive.value = []
  }

  const setActualities = (getActualities) => {
    actualitiesToday.value = []
    actualitiesProgram.value = []
    actualitiesNotice.value = []
    actualitiesArchive.value = []

    let items = [...getActualities]
    const today = new Date()
    const todayYear = today.getFullYear()
    const todayMonth = today.getMonth()
    const todayDay = today.getDate()
    const copyToday = new Date(todayYear, todayMonth, todayDay)

    items.sort((a, b) => {
      const aFrom = new Date(a.node.NoticeFields.dateFrom)
      const aFromCopy = new Date(
        aFrom.getFullYear(),
        aFrom.getMonth(),
        aFrom.getDate()
      )
      const bFrom = new Date(b.node.NoticeFields.dateFrom)
      const bFromCopy = new Date(
        bFrom.getFullYear(),
        bFrom.getMonth(),
        bFrom.getDate()
      )

      const aHighlightUntil = new Date(a.node.NoticeFields.highlightUntil)
      const bHighlightUntil = new Date(b.node.NoticeFields.highlightUntil)
      const aHighlight = copyToday.getTime() < aHighlightUntil.getTime()
      const bHighlight = copyToday.getTime() < bHighlightUntil.getTime()

      if (aHighlight && bHighlight) {
        return aFromCopy.getTime() - bFromCopy.getTime()
      } else if (aHighlight && !bHighlight) {
        return -1
      } else if (!aHighlight && bHighlight) {
        return 1
      } else {
        return aFromCopy.getTime() - bFromCopy.getTime()
      }
    })

    actualities.value = items

    items.forEach((actualitie) => {
      const dateTo = new Date(actualitie.node.NoticeFields.dateTo)
      const copyDateTo = new Date(
        dateTo.getFullYear(),
        dateTo.getMonth(),
        dateTo.getDate()
      )
      const dateFrom = new Date(actualitie.node.NoticeFields.dateFrom)
      const copyDateFrom = new Date(
        dateFrom.getFullYear(),
        dateFrom.getMonth(),
        dateFrom.getDate()
      )

      // actualitiesNotice
      if (actualitie.node.NoticeFields.dateFrom == null) {
        actualitiesNotice.value.push(actualitie)
      }
      // actualitiesArchive
      else if (
        copyDateTo.getTime() < copyToday.getTime() &&
        copyDateFrom.getTime() < copyToday.getTime()
      ) {
        actualitiesArchive.value.push(actualitie)
      }
      // actualitiesToday
      if (copyDateFrom.getTime() === copyToday.getTime()) {
        actualitiesToday.value.push(actualitie)
      } else if (
        copyDateTo.getTime() >= copyToday.getTime() &&
        copyDateFrom.getTime() <= copyToday.getTime()
      ) {
        actualitiesToday.value.push(actualitie)
      }
      // actualitiesProgram
      if (copyDateFrom.getTime() > copyToday.getTime()) {
        actualitiesProgram.value.push(actualitie)
      }
    })
  }

  const setArchive = (getActualities) => {
    let items = [...getActualities]
    const today = new Date()
    const todayYear = today.getFullYear()
    const todayMonth = today.getMonth()
    const todayDay = today.getDate()
    const copyToday = new Date(todayYear, todayMonth, todayDay)

    items.sort((a, b) => {
      const aFrom = new Date(a.node.NoticeFields.dateFrom)
      const aFromCopy = new Date(
        aFrom.getFullYear(),
        aFrom.getMonth(),
        aFrom.getDate()
      )
      const bFrom = new Date(b.node.NoticeFields.dateFrom)
      const bFromCopy = new Date(
        bFrom.getFullYear(),
        bFrom.getMonth(),
        bFrom.getDate()
      )

      const aHighlightUntil = new Date(a.node.NoticeFields.highlightUntil)
      const bHighlightUntil = new Date(b.node.NoticeFields.highlightUntil)
      const aHighlight = copyToday.getTime() < aHighlightUntil.getTime()
      const bHighlight = copyToday.getTime() < bHighlightUntil.getTime()

      if (aHighlight && bHighlight) {
        return bFromCopy.getTime() - aFromCopy.getTime()
      } else if (aHighlight && !bHighlight) {
        return -1
      } else if (!aHighlight && bHighlight) {
        return 1
      } else {
        return bFromCopy.getTime() - aFromCopy.getTime()
      }
    })

    items.forEach((actualitie) => {
      const dateTo = new Date(actualitie.node.NoticeFields.dateTo)
      const copyDateTo = new Date(
        dateTo.getFullYear(),
        dateTo.getMonth(),
        dateTo.getDate()
      )
      const dateFrom = new Date(actualitie.node.NoticeFields.dateFrom)
      const copyDateFrom = new Date(
        dateFrom.getFullYear(),
        dateFrom.getMonth(),
        dateFrom.getDate()
      )

      // actualitiesNotice
      if (actualitie.node.NoticeFields.dateFrom == null) {
        actualitiesNotice.value.push(actualitie)
      }
      // actualitiesArchive
      else if (
        copyDateTo.getTime() < copyToday.getTime() &&
        copyDateFrom.getTime() < copyToday.getTime()
      ) {
        actualitiesArchive.value.push(actualitie)
      }
      // actualitiesToday
      if (copyDateFrom.getTime() === copyToday.getTime()) {
        actualitiesToday.value.push(actualitie)
      } else if (
        copyDateTo.getTime() >= copyToday.getTime() &&
        copyDateFrom.getTime() <= copyToday.getTime()
      ) {
        actualitiesToday.value.push(actualitie)
      }
      // actualitiesProgram
      if (copyDateFrom.getTime() > copyToday.getTime()) {
        actualitiesProgram.value.push(actualitie)
      }
    })
  }

  const resetActualities = () => {
    restart()
  }

  const getActualitiesToday = computed(() => actualitiesToday.value)
  const getActualitiesProgram = computed(() => actualitiesProgram.value)
  const getActualitiesNotice = computed(() => actualitiesNotice.value)
  const getActualitiesArchive = computed(() => actualitiesArchive.value)
  const getActualitiesBySlug = computed(() => (slug) => {
    return actualities.value.find((item) => item.node.slug === slug)
  })

  return {
    actualities,
    actualitiesToday,
    actualitiesProgram,
    actualitiesNotice,
    actualitiesArchive,
    setActualities,
    setArchive,
    resetActualities,
    getActualitiesToday,
    getActualitiesProgram,
    getActualitiesNotice,
    getActualitiesArchive,
    getActualitiesBySlug,
  }
})
